var map = {
	"./en.ts": [
		"84ff",
		"lang-en-ts"
	],
	"./helpers.ts": [
		"e0bf",
		"lang-en-ts"
	],
	"./nl.ts": [
		"2e91",
		"lang-en-ts"
	],
	"./pebbles.ts": [
		"e572",
		"lang-pebbles-ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c3f9";
module.exports = webpackAsyncContext;